import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import type { ErrorCategory } from './ErrorUtils';
import { createErrorHandler } from './ErrorUtils';

interface GenericErrorBoundaryProps {
  children: React.ReactNode;
  type: ErrorCategory;
  identifier: string;
  fallback: (error: Error, reset: () => void) => React.ReactNode;
  onReset?: () => void;
}

export const GenericErrorBoundary: React.FC<GenericErrorBoundaryProps> = ({
  children,
  type,
  identifier,
  fallback,
  onReset,
}) => {
  const handleError = createErrorHandler(type, identifier);

  return (
    <ErrorBoundary
      FallbackComponent={({ error, resetErrorBoundary }) => fallback(error as Error, resetErrorBoundary)}
      onError={handleError}
      onReset={onReset}
    >
      {children}
    </ErrorBoundary>
  );
};
